<template>
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90.07 90.07">
  <path class="cls-2" d="m57.19,81.11c-.33,0-.66-.1-.93-.31l-11.22-8.33-11.22,8.33c-.47.35-1.11.41-1.63.14-.53-.27-.86-.81-.86-1.39v-32.64c0-.86.7-1.56,1.56-1.56s1.56.7,1.56,1.56v29.53l9.66-7.17c.55-.41,1.31-.41,1.86,0l9.66,7.17v-20.33c0-.86.7-1.56,1.56-1.56s1.56.7,1.56,1.56v23.44c0,.59-.33,1.13-.86,1.39-.22.11-.46.17-.7.17Z"/>
  <path class="cls-2" d="m45.04,45.01c-7.98,0-14.48-6.5-14.48-14.48s6.5-14.48,14.48-14.48,14.48,6.5,14.48,14.48-6.49,14.48-14.48,14.48Zm0-26.88c-6.84,0-12.4,5.56-12.4,12.4s5.56,12.4,12.4,12.4,12.4-5.56,12.4-12.4-5.56-12.4-12.4-12.4Z"/>
  <path class="cls-1" d="m45.04,52.09c-11.89,0-21.56-9.67-21.56-21.56s9.67-21.56,21.56-21.56,21.56,9.67,21.56,21.56-9.67,21.56-21.56,21.56Zm0-40c-10.17,0-18.44,8.27-18.44,18.44s8.27,18.44,18.44,18.44,18.44-8.27,18.44-18.44-8.27-18.44-18.44-18.44Z"/>
  <path class="cls-3" d="m45.09,37.21c-.29,0-.57-.08-.82-.23l-5.87-3.6c-.74-.45-.97-1.41-.51-2.15.45-.74,1.41-.97,2.15-.51l4.49,2.75,4.97-8.84c.42-.75,1.37-1.02,2.13-.6.75.42,1.02,1.38.6,2.13l-5.77,10.25c-.21.37-.56.64-.97.75-.13.03-.26.05-.39.05Z"/>
</svg>
</template>

<script>
export default {
    name: "SkuRankIcon",
}
</script>

<style scoped>
  .cls-1 {
    fill: #0f5b71;
  }
  .cls-2 {
    fill: #59c5c7;
  }
  .cls-3 {
    fill: #cfeae0;
  }
</style>